import styled from 'styled-components'
import { Card, CardTitle, CardContent } from '../Layout/CommonStyle'
import {
  MdPeople,
  MdExpandMore,
  MdExpandLess,
  MdThumbUpOffAlt,
} from 'react-icons/md'

type ReplyParam = {
  name: string
  datetime?: string
  description: string
}

function Reply(replyParam: ReplyParam) {
  return (
    <Container>
      <MdPeople className="icon" />
      <Name>{replyParam.name}</Name>
      <div>{replyParam.description}</div>
    </Container>
  )
}

const Container = styled.div`
  padding: 10px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
  column-gap: 0.3rem;
  color: #666;
  background-color: #eee;

  svg {
    font-size: 16px;
    width: 20px;
    height: 20px;
  }
`

const Name = styled.div`
  min-width: 4rem;
`

export default Reply
